/**
 * Use this file for JavaScript code that you want to run in the front-end 
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any 
 * JavaScript running in the front-end, then you should delete this file and remove 
 * the `viewScript` property from `block.json`. 
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */


const filters = document.querySelector('#events_filter_form');
if (filters) {
	const selects = filters.querySelectorAll('select');
	selects.forEach((select) => {
		select.addEventListener('change', () => {
			const selectedValue = select.value;
			if (selectedValue.length === 0) {
				window.location = window.location.origin + window.location.pathname;
			} else {
				window.location = selectedValue;
				// filters.submit();
			}
		});
	});
}